import { availableMasterOfCeremoniesJobTypes } from '../../../../../../../../../helpers/availableJobTypeHelper'
import availableSizes from '../../../../../../../../../helpers/sizeHelper'
import pastJob from '../../../../../dto/pastJobs'
import media from '../../../../../dto/media'

export default function() {
    let medias = []
    for (let i = 1; i <= 4; i++) {
        let photo = Object.assign({}, media)
        photo.type = 'photo'

        medias.push(photo)
    }
    let video = Object.assign({}, media)
    video.type = 'video'
    medias.push(video)

    return {
        availableMasterOfCeremoniesJobTypes,
        availableSizes,
        profile: {
            category: 'master_of_ceremonies',
            fees: [],
            pastJobs: [{...pastJob}],
            media: medias,
            types: []
        },
        errors: {
            hairColor: null,
            ethnicity: null,
            fee: null,
            types: null,
            pastJobs: []
        },
        showCropper: false,
        showVideoInput: false,
        videoObj: null,
        croppingImage: null,
        videoError: null
    }
}
